package org.abhranilnxt.portfolio.models

enum class Projects(
    val image: String,
    val title: String,
    val description: String,
    val githubLink: String,
    val liveLink: String
) {
    KokoroList(
        image = "kokoro_img.png",
        title = "Kokoro List",
        description = "An Anime Watchlist Application designed to streamline your anime watching experience.",
        githubLink = "https://github.com/AbhranilNXT/Kokoro-List",
        liveLink = "https://github.com/AbhranilNXT/Kokoro-List/releases/download/v1.0.3/Kokoro.List.v1.0.3.apk"
    ),
    Kritique(
        image = "kritique_img.png",
        title = "Kritique",
        description = "A review system app for reviewing the Teachers and rating them on the basics of teaching and other parameters.",
        githubLink = "https://github.com/iot-lab-kiit/IoT-Teacher-Review-App",
        liveLink = "https://play.google.com/store/apps/details?id=in.iot.lab.kritique"
    ),
    Matrix(
        image = "matrix_img.jpg",
        title = "Matrix",
        description = "An Android Application which was created by IoT lab Android Team for a Scavenger Hunt game organised in KIIT Fest 7.0.",
        githubLink = "https://github.com/iot-lab-kiit/Scavenger-Hunt-App",
        liveLink = "https://github.com/iot-lab-kiit/Scavenger-Hunt-App/releases/download/2.0.0/Scavenger-Hunt-v2.0.0.apk"
    ),
    ComposeQR(
        image = "composeqr_img.png",
        title = "Compose QR Generator",
        description = "An open-source Jetpack Compose Library used to generate QR Code from text or url.",
        githubLink = "https://github.com/AbhranilNXT/ComposeQRGenerator",
        liveLink = "https://jitpack.io/#AbhranilNXT/ComposeQRGenerator"
    ),
    Weather(
        image = "weather_img.png",
        title = "Weather App",
        description = "An Android Application which fetches weather data from OpenWeather and displays it.",
        githubLink = "https://github.com/AbhranilNXT/WeatherApp",
        liveLink = "https://github.com/AbhranilNXT/WeatherApp"
    )
}